import { useCallback } from 'react';
import { PureRelatedItems } from '../RelatedItems/PureRelatedItems';

interface NewRelatedItemsProps {
  relatedTradeId: string;
  platform: General.PlatformUpperCase;
  storeId: string;
  relatedSku: Todo.RelatedSku[];
  externalBuyerId: string;
  ready: boolean;
  onChange: (next: Todo.RelatedSku[]) => void;
}

export const NewRelatedItems = (props: NewRelatedItemsProps) => {
  const { relatedTradeId, platform, storeId, relatedSku, externalBuyerId, ready, onChange } = props;

  const handleSelect = useCallback(
    (item: Conversation.Trade.Product | null) => {
      if (!item) return;
      const next: Todo.RelatedSku[] = [
        {
          itemId: item.externalItemId,
          skuId: item.externalSkuId || '',
          skuName: item.skuName || '',
          sellerSku: item.sellerSku || '',
          quantity: item.quantity ?? 1,
          itemName: item.itemName || '',
        },
      ];
      onChange(next);
    },
    [onChange],
  );

  const handleQuantityChange = useCallback(
    (index: number, quantity: number) => {
      const next = [...relatedSku];
      if (!next[index]) return;
      next[index] = { ...next[index], quantity };
      onChange(next);
    },
    [onChange, relatedSku],
  );

  const handleClear = useCallback(() => {
    onChange([]);
  }, [onChange]);

  return (
    <PureRelatedItems
      canEdit
      ready={ready}
      relatedTradeId={relatedTradeId}
      platform={platform}
      storeId={storeId}
      relatedSku={relatedSku}
      externalBuyerId={externalBuyerId}
      onSelect={handleSelect}
      onQuantityChange={handleQuantityChange}
      onClear={handleClear}
    />
  );
};
